/**
 * Notify Me (Back in Stock) - custom email capture
 * Shopify has no native inventory webhook trigger without an app.
 * This script captures the email + product/variant info for sold-out
 * products. If NOTIFY_ME_ENDPOINT is set below, it POSTs the data to
 * that endpoint (e.g. a serverless function, Klaviyo, Google Sheet).
 * Otherwise, it stores signups in localStorage as 'notifyMeSignups'
 * so the merchant can retrieve/export them later.
 */
(function () {
  var NOTIFY_ME_ENDPOINT = null;

  function handleSubmit(form) {
    var wrapper = form.closest('[data-notify-me-form]');
    var messageEl = wrapper ? wrapper.querySelector('[data-notify-me-message]') : null;
    var emailInput = form.querySelector('input[type="email"]');
    var variantInput = form.querySelector('input[name="variant_id"]');
    var productTitleInput = form.querySelector('input[name="product_title"]');

    if (!emailInput || !emailInput.value) {
      return;
    }

    var payload = {
      email: emailInput.value,
      variant_id: variantInput ? variantInput.value : null,
      product_title: productTitleInput ? productTitleInput.value : null,
      page_url: window.location.href,
      created_at: new Date().toISOString()
    };

    if (wrapper) wrapper.classList.add('is-loading');

    var showMessage = function (text, isError) {
      if (!messageEl) return;
      messageEl.textContent = text;
      messageEl.hidden = false;
      messageEl.removeAttribute('data-success');
      messageEl.removeAttribute('data-error');
      messageEl.setAttribute(isError ? 'data-error' : 'data-success', '');
    };

    if (!NOTIFY_ME_ENDPOINT) {
      try {
        var stored = JSON.parse(localStorage.getItem('notifyMeSignups') || '[]');
        stored.push(payload);
        localStorage.setItem('notifyMeSignups', JSON.stringify(stored));
      } catch (e) {}

      if (wrapper) wrapper.classList.remove('is-loading');
      showMessage('多謝！補貨時我們會電郵通知您。', false);
      form.reset();
      return;
    }

    fetch(NOTIFY_ME_ENDPOINT, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(payload)
    })
      .then(function (res) {
        if (!res.ok) throw new Error('Request failed');
        return res.json().catch(function () { return {}; });
      })
      .then(function () {
        showMessage('多謝！補貨時我們會電郵通知您。', false);
        form.reset();
      })
      .catch(function () {
        showMessage('發生錯誤，請重試。', true);
      })
      .finally(function () {
        if (wrapper) wrapper.classList.remove('is-loading');
      });
  }

  document.addEventListener('submit', function (event) {
    var form = event.target;
  var emailWrap = form.querySelector('[data-notify-me-email-wrap]');
  if (emailWrap && emailWrap.hasAttribute('hidden')) {
    event.preventDefault();
    emailWrap.removeAttribute('hidden');
    var emailInput = emailWrap.querySelector('input[type="email"]');
    if (emailInput) emailInput.focus();
    return;
  }
    if (!form || !form.matches('[data-notify-me-fields]')) return;
    event.preventDefault();
    handleSubmit(form);
  });
})();
